import { Popover, SxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getAdvancedPopoverRootSx } from 'components/Search/styles';
import { memo } from 'react';

interface OmniModalPopoverProps {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  sx?: SxProps;
  children: React.ReactNode;
}

export const OmniModal = memo(
  ({ anchorEl, handleClose, sx, children }: OmniModalPopoverProps) => {
    const theme = useTheme();

    return (
      <Popover
        id="omni-modal-popover"
        data-testid="omni-modal-popover"
        disableEnforceFocus={true}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        keepMounted={true}
        elevation={3}
        marginThreshold={8}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          top: '52px',
          '& .MuiBackdrop-root': {
            ...getAdvancedPopoverRootSx(theme),
          },
          '> .MuiPaper-root': {
            border: `1px solid ${theme.palette.divider}`,
            minHeight: '100px',
            minWidth: '100px',
          },
          ...sx,
        }}
      >
        {children}
      </Popover>
    );
  },
);
OmniModal.displayName = 'OmniModal';
